<template>
  <div @click="hide" v-show="presentMode" class="present-mode-item-container" :style="containerStyle">
    <div class="present-mode-item-btn" :style="iconColor">
      <svg-icon
          color="currentColor"
          icon-class="hide"
      />
    </div>
    <span class="present-mode-btn-text" :style="textColor">
          点击显示
    </span>
  </div>
</template>
<script setup>
import {useEventBus} from "@vueuse/core";
import {ref} from "vue";

const props = defineProps({
  theme: {},
  prop: {},
  option: {},
  isDark: {}
})
const presentMode = ref(localStorage.getItem('presentMode') === 'true')
const presentModeEvent = useEventBus('presentMode')
presentModeEvent.on((v) => {
  presentMode.value = v
})
const themeColor = computed(() => {
  return props?.theme?.barColor?.[0]?.color1;
})
const containerStyle = computed(() => {
  return {
    backgroundColor: props.isDark ? 'rgba(255, 255, 255, 0.3)' : '#ffffffbd'
  };
})
const textColor = computed(() => {
  return {
    color: props.isDark ? '#fff' : '#484a4d'
  };
})
const iconColor = computed(() => {
  return {
    color: themeColor.value
  };
})

function hide() {
  presentMode.value = false
}
</script>
<style lang="scss">
.present-mode-item-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 40px;
  backdrop-filter: blur(4px);
}

.present-mode-item-btn {
  font-size: 50px;
  color: #4D85FF;
}

.present-mode-btn-text {
  font-size: 14px;
  font-weight: 400;
}
</style>